'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { ShortLayout } from './layouts/ShortLayout/ShortLayout.js';
import { FullLayout } from './layouts/FullLayout/FullLayout.js';
import { AppItem } from './slots/AppItem/AppItem.js';

var FooterApp = function(props) {
    var title = props.title, variant = props.variant, items = props.items, qrCode = props.qrCode, image = props.image, locale = props.locale, onItemClick = props.onItemClick, _props_renderAppItem = props.renderAppItem, renderAppItem = _props_renderAppItem === void 0 ? AppItem : _props_renderAppItem;
    if (variant === "short") {
        return /*#__PURE__*/ jsx(ShortLayout, {
            items: items,
            locale: locale,
            renderAppItem: renderAppItem,
            title: title,
            onItemClick: onItemClick
        });
    }
    if (variant === "full") {
        return /*#__PURE__*/ jsx(FullLayout, {
            image: image,
            items: items,
            locale: locale,
            qrCode: qrCode,
            renderAppItem: renderAppItem,
            title: title,
            onItemClick: onItemClick
        });
    }
    return null;
};

export { FooterApp };
